import { render, staticRenderFns } from "./MelosContentCollection.vue?vue&type=template&id=09d4f502&"
import script from "./MelosContentCollection.vue?vue&type=script&lang=ts&"
export * from "./MelosContentCollection.vue?vue&type=script&lang=ts&"
import style0 from "./MelosContentCollection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports